// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._0dcEVmYxGZXO_KzIXRHA{position:relative;display:flex;flex-grow:1;margin-left:16px}`, "",{"version":3,"sources":["webpack://./src/pages/clickToText/pages/viewClickToText/ui/%D1%81lickToTextStatisticsTableClicks/styles.module.scss"],"names":[],"mappings":"AAAA,uBACE,iBAAA,CACA,YAAA,CACA,WAAA,CACA,gBAAA","sourcesContent":[".wrapTable {\n  position: relative;\n  display: flex;\n  flex-grow: 1;\n  margin-left: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapTable": `_0dcEVmYxGZXO_KzIXRHA`
};
export default ___CSS_LOADER_EXPORT___;
